// v6 Fase F1 — Categoriseer een room-action in één van 4 logische secties.
//
// Volgorde (1e match wint):
//  1. PLAFONDWERKEN — auto_kind=ceiling OR description contains "plafond"
//  2. HOUTWERK_LAKWERK — code begint met S-04 OR auto_kind ∈ {plinten} OR
//                         description-match (deur/raam/plint/trapleun/radiator)
//  3. WANDWERKEN — auto_kind=walls OR work_category begint met "B-" (behang) OR
//                  code begint met S-07 (decoratieve muurtechnieken) OR
//                  description-match (muur/wand/behang/vlies/renovlies)
//  4. ANDERE — alles wat hierboven niet matcht (voorbereiding, kit, regie,
//              forfaits, vloer, primer als losse stap, etc.)
//
// Custom measurements (geen default-match) gaan altijd onder ANDERE.

export const ROOM_SECTIONS = {
  walls:    { key: "walls",    label: "Wandwerken",          order: 1 },
  ceiling:  { key: "ceiling",  label: "Plafondwerken",       order: 2 },
  woodwork: { key: "woodwork", label: "Houtwerk / lakwerk",  order: 3 },
  other:    { key: "other",    label: "Andere regels",       order: 4 },
};

const ORDER = ["walls", "ceiling", "woodwork", "other"];

export function categorizeAction(action, priceCode) {
  const desc = ((action?.label || priceCode?.description || "") + "").toLowerCase();
  const code = (action?.code || priceCode?.code || "").toUpperCase();
  const wc = (priceCode?.work_category || "").toUpperCase();
  const kind = action?.auto_kind;

  // 1. Plafondwerken
  if (kind === "ceiling") return "ceiling";
  if (/\bplafond/.test(desc)) return "ceiling";

  // 2. Houtwerk / lakwerk
  if (code.startsWith("S-04")) return "woodwork";
  if (kind === "plinten") return "woodwork";
  if (/\b(deur|raam|plint|trapleun|radiator|deuromlijst|venster|schrijnwerk)/.test(desc)) {
    return "woodwork";
  }

  // 3. Wandwerken
  if (kind === "walls") return "walls";
  if (code.startsWith("B-")) return "walls"; // behang/vlies/...
  if (code.startsWith("S-07")) return "walls"; // decoratieve wandafwerking
  if (/\b(muur|muren|wand|wanden|behang|vlies|renovlies|tasso|kalkverf|limewash|betonlook|wabi|venetian|stucco)/.test(desc)) {
    return "walls";
  }
  if (wc.startsWith("S-03 SCHILDER")) return "walls"; // S-03 sectie blijft wand-georiënteerd (primer muren etc.)

  // 4. Andere
  return "other";
}

// Groepeer een lijst van acties + custom measurements in vier secties.
// Returns: [{ key, label, actions: [...], customMs: [...] }, ...] — alleen
// secties met inhoud worden opgenomen, in vaste volgorde.
export function groupRoomActions({ defaults, customMs, codeByCode }) {
  const buckets = { walls: [], ceiling: [], woodwork: [], other: [] };
  (defaults || []).forEach((a) => {
    const pc = codeByCode?.[a.code];
    const sec = categorizeAction(a, pc);
    buckets[sec].push(a);
  });
  const customBuckets = { walls: [], ceiling: [], woodwork: [], other: [] };
  (customMs || []).forEach((m) => {
    // Build a synthetic action shape for categorization purposes
    const pseudo = { label: m.description, code: m.action_code, auto_kind: m.auto_kind };
    const pc = m.price_code_id ? null : null; // we don't always have a pc here
    const sec = categorizeAction(pseudo, pc);
    customBuckets[sec].push(m);
  });
  return ORDER
    .map((key) => ({
      key,
      label: ROOM_SECTIONS[key].label,
      actions: buckets[key],
      customMs: customBuckets[key],
    }))
    .filter((s) => s.actions.length > 0 || s.customMs.length > 0);
}
